import { EventClass, EventType } from "../_game/config/Events";
import { ENABLE_LOGGING, GAME_SOUNDS } from "../_game/config/Game";
import { __EventDispatcher, __LocalStorage, __Store, __Utils } from "./core";

export default class SoundManager {
  resources: any = [];
  private isLoaded: boolean = false;

  private musicVolume: number;
  private sfxVolume: number;
  private musicMute: boolean;
  private sfxMute: boolean;

  constructor() {
    this.musicVolume = __LocalStorage.state.VOLUME_MUSIC;
    this.sfxVolume = __LocalStorage.state.VOLUME_SFX;

    this.musicMute = __LocalStorage.state.MUTE_BG;
    this.sfxMute = __LocalStorage.state.MUTE_SFX;

    __EventDispatcher.addListener(
      EventClass.SOUND,
      this.onEventDispatched,
      this
    );
    this._LOG("Sound Manager:: Init");
  }

  async load(onLoadReady?: Function) {
    return await this.loadItems();
  }

  async loadItems() {
    let _filesToLoad: any[] = [];

    GAME_SOUNDS.forEach(async (value, key) => {
      _filesToLoad.push({
        name: key,
        file: value,
      });
    });
    await Promise.all(
      _filesToLoad.map(async (item: any) => {
        let _file: any = await import("../assets/sounds/" + item.file);
        const audio = new Audio(_file.default);

        // audio.onloadeddata  = async() => {
        this.resources[item.name] = {
          sound: audio,
          channel: "sfx",
        };
        // }
      })
    );
    return this.resources;
  }

  setVolume(_strChannel: string, _volume: any) {
    // saves volume in this.sfxVolume and this.musicVolume
    this[(_strChannel + "Volume") as keyof typeof this] = _volume;

    for (let res in this.resources) {
      if (__Utils.isSet(this.resources[res].sound)) {
        const sound = this.resources[res].sound;
        const channel = this.resources[res].channel;
        if (channel === _strChannel) {
          if (!this[_strChannel as keyof typeof this] + "Mute") {
            sound.volume = _volume;
          }
        }
      }
    }

    this._LOG(
      "SoundManager - received setVolume channel [" +
        _strChannel +
        "]:" +
        _volume
    );
  }

  muteChannel(_strChannel: string, _bMute: any) {
    for (let res in this.resources) {
      if (__Utils.isSet(this.resources[res])) {
        const sound = this.resources[res].sound;
        const channel = this.resources[res].channel;

        if (channel === _strChannel) {
          this[(_strChannel + "Mute") as keyof typeof this] = _bMute;

          if (_bMute) {
            sound.volume = 0;
          } else {
            sound.volume = this[(_strChannel + "Volume") as keyof typeof this];
          }
        }
      }
    }

    this._LOG(
      "SoundManager - received mute channel [" + _strChannel + "]:" + _bMute
    );
  }

  play(soundAlias: string, looping: boolean = false) {
    if (soundAlias === "") return;

    if (typeof this.resources[soundAlias] === "undefined") {
      this._LOG(
        "[ERROR] SoundManager.play - sound not found: [" + soundAlias + "]"
      );
      return;
    }
    if (__LocalStorage.state.MUTE_SFX) return;

    this.resources[soundAlias].sound.looping = looping;
    this.resources[soundAlias].sound.currentTime = 0;
    this.resources[soundAlias].sound.volume = 0.2;
    this.resources[soundAlias].sound.play();

    this._LOG("SoundManager - play sound: [" + soundAlias + "]:");
  }

  stop(soundAlias: string, looping: boolean = false) {
    if (soundAlias === "") return;

    if (typeof this.resources[soundAlias] === "undefined") {
      this._LOG(
        "[ERROR] SoundManager.play - sound not found: [" + soundAlias + "]"
      );
      return;
    }

    this.resources[soundAlias].sound.looping = looping;
    this.resources[soundAlias].sound.stop();

    this._LOG("SoundManager - stop sound: [" + soundAlias + "]:");
  }

  onEventDispatched(
    eventClass: EventClass,
    eventType: string,
    eventPayload: any
  ) {
    if (eventClass === EventClass.SOUND) {
      switch (eventType) {
        case EventType.SOUND.PLAY:
          this.play(eventPayload.soundID, eventPayload.bLooping);
          break;

        case EventType.SOUND.STOP:
          this.stop(eventPayload.soundID);
          break;
      }
    }
  }

  private _LOG(_message: any) {
    if (!ENABLE_LOGGING) return;

    console.groupCollapsed(
      "%c AUDIO MANAGER                  ",
      "background: #ff9914; color: white; display: block;"
    );

    console.log(_message);
    console.groupEnd();
  }
}

export function SND_PLAY(_sndID: string, _bLooping: boolean = false) {
  if (typeof _sndID === "undefined" || _sndID === "") return;

  let lStore = __Store.getState();

  if (!lStore.app.userInteraction) return false;

  __EventDispatcher.dispatch(EventClass.SOUND, EventType.SOUND.PLAY, {
    soundID: _sndID,
    bLooping: _bLooping ? _bLooping : false,
  });
}

export function SND_STOP(_sndID: string) {
  __EventDispatcher.dispatch(EventClass.SOUND, EventType.SOUND.STOP, {
    soundID: _sndID,
  });
}
